"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Provides a simple implementation of the {@link IIriTemplateExpansionStrategy} interface where an input resource
 * is used to fill the possible {@link IIriTemplate} with values.
 */
class BodyResourceBoundIriTemplateExpansionStrategy {
    /** @inheritDoc */
    createRequest(operation, body, auxResource) {
        const templatedOperation = operation;
        if (typeof templatedOperation.expandTarget === "function") {
            return templatedOperation.expandTarget(builder => this.withResourceVariables(builder, body || {}, auxResource || {}));
        }
        return operation;
    }
    withResourceVariables(builder, body, auxResource) {
        const variableMappings = builder.variableMappings;
        for (const variableName of Object.keys(variableMappings)) {
            const property = variableMappings[variableName];
            const literal = typeof body[property] !== "undefined" ? body[property].toString() : auxResource[property] || null;
            builder.withVariable(variableName).havingValueOf(literal);
        }
    }
}
exports.default = BodyResourceBoundIriTemplateExpansionStrategy;
//# sourceMappingURL=BodyResourceBoundIriTemplateExpansionStrategy.js.map